const realmTheme = process.env.VUE_APP_THEME_REALM ?? process.env.VUE_APP_KEYCLOAK_REALM;

export default {
  created() {
    this.generateManifest();
  },

  methods: {
    generateManifest() {
      this.removeOldManifest();

      const baseUrl = `${window.location.origin}/`;

      const manifestContent = {
        name: 'Procon Web',
        short_name: 'ProconWeb',
        background_color: '#f8f8f8',
        theme_color: this.$t('SUBHEADER.color'),
        description: 'Faça reclamações com muita praticidade.',
        lang: 'pt-BR',
        start_url: `${baseUrl}`,
        display: 'standalone',
        orientation: 'portrait',
        icons: [
          {
            src: `${baseUrl}img/themes/${realmTheme}/favicon.png`,
            type: 'image/png',
            sizes: '144x144',
          },
        ],
        prefer_related_applications: false,
      };

      const stringManifest = JSON.stringify(manifestContent);
      const blobFile = new File([stringManifest], 'manifest.json', {
        type: 'application/json',
      });
      const manifestURL = URL.createObjectURL(blobFile);

      const link = document.createElement('link');

      link.rel = 'manifest';
      link.href = manifestURL;
      document.head.appendChild(link);
    },

    removeOldManifest() {
      const manifest = document.querySelector('link[rel="manifest"]');

      if (manifest) {
        manifest.remove();
      }
    },
  },
};
